// extracted by mini-css-extract-plugin
export default {"container":"src-pages-SalesCannelVersion-SalesChannelEditorMaintenancePage-Preview-style-module__container--TD2tp"};